import {AsyncPipe} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatTooltip} from '@angular/material/tooltip';
import {AssetService} from '@app/asset';
import {Stream} from '@app/stream/models';
import {StreamService} from '@app/stream/stream.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
    selector: 'frog-stream-move-menu',
    templateUrl: './stream-move-menu.component.html',
    styleUrls: ['./stream-move-menu.component.scss'],
    imports: [MatMenuItem, MatMenuTrigger, MatIcon, MatMenu, MatTooltip, AsyncPipe],
})
export class StreamMoveMenuComponent implements OnInit {
    @Input() streamId: string;
    @Input() assets: string[];
    @Input() copy: boolean = false;
    @Output() select: EventEmitter<string>;

    public streams$: Observable<Stream[]>;

    constructor(
        private assetService: AssetService,
        private streamService: StreamService,
        private matSnackBar: MatSnackBar,
    ) {
        this.select = new EventEmitter<string>();
    }

    ngOnInit(): void {
        this.streams$ = this.streamService.streams.pipe(
            map((streams) => streams.filter((stream) => stream.parent === null)),
            map((streams) => streams.sort()),
        );
    }

    action(assetIds: string[], streamId: string, fromStreamId: string): void {
        if (this.copy) {
            this.copyToStream(assetIds, streamId);
        } else {
            this.moveToStream(assetIds, streamId, fromStreamId);
        }
        this.select.emit(streamId);
    }

    moveToStream(assetIds: string[], streamId: string, fromStreamId: string) {
        const assetIdsToRemove = assetIds.slice();
        this.streamService.assignAssets(streamId, assetIds, fromStreamId).subscribe(() => {
            this.assetService.removeAssets(assetIdsToRemove);
            this.matSnackBar.open('Asset(s) moved', null, { duration: 2000 });
        });
    }

    copyToStream(assetIds: string[], streamId: string) {
        this.streamService.assignAssets(streamId, assetIds).subscribe(() => {
            this.matSnackBar.open('Asset(s) copied', null, { duration: 2000 });
        });
    }
}
